import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Your Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDIzHDaWpDqL_X3NFDSrkN3wejV_qiagfM",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "srf-bill.firebaseapp.com",
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || "https://srf-bill-default-rtdb.firebaseio.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "srf-bill",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "srf-bill.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "102406855964",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:102406855964:web:8703311a12056416a52ed9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

export default app;